import { RoutePaths } from "@/config/route-paths";

export function getCreateCredentialSheetBack({
  customerId,
  organizationId,
  sport,
}: {
  customerId: number;
  organizationId: string;
  sport: string;
}) {
  return RoutePaths.credentials.list({ customerId, organizationId, sport });
}
